import { PaletteIcon } from 'lucide-react'
import { useT } from '@/session/useSession'
import { isTheme, THEMES, useTheme } from '@/session/useTheme'
import { IconButton } from '../IconButton/IconButton'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'

export function ThemeToggle() {
  const t = useT()
  const { theme, setTheme, highContrast, setHighContrast } = useTheme()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <IconButton label={t('theme.legend')}>
            <PaletteIcon />
          </IconButton>
        }
      />
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup
          value={theme}
          onValueChange={(next) => {
            if (isTheme(next)) setTheme(next)
          }}
        >
          {THEMES.map((option) => (
            <DropdownMenuRadioItem key={option} value={option}>
              {t(`theme.${option}.name`)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
        <DropdownMenuSeparator />
        <DropdownMenuCheckboxItem
          checked={highContrast}
          onCheckedChange={(next) => setHighContrast(next)}
        >
          {t('theme.contrast.name')}
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
